import React from 'react';
import { ChevronRight } from 'lucide-react';

interface MenuItemProps {
  icon?: React.ReactNode;
  label: string;
  shortcut?: string;
  onClick?: () => void;
  variant?: 'default' | 'danger' | 'active';
  hasSubmenu?: boolean;
}

export const MenuItem: React.FC<MenuItemProps> = ({ icon, label, shortcut, onClick, variant = 'default', hasSubmenu }) => (
  <button
    className={`
      w-full text-left px-3 py-1.5 text-xs flex items-center gap-2 transition-all duration-150 group
      ${variant === 'danger' ? 'text-red-400 hover:bg-red-600 hover:text-white' :
        variant === 'active' ? 'bg-brand-600 text-white' :
        'text-dark-text hover:bg-brand-600 hover:text-white'}
    `}
    onClick={(e) => {
      e.stopPropagation();
      if(onClick) onClick();
    }}
    data-testid='unknown-action-btn'
    data-ux='action'
    data-interaction-id='unknown-action-btn'>
    <span className={`w-4 h-4 flex items-center justify-center ${variant === 'active' ? 'opacity-100' : 'opacity-70 group-hover:opacity-100'}`}>{icon}</span>
    <span className="flex-1 truncate">{label}</span>
    {shortcut && <span className="text-[10px] opacity-50">{shortcut}</span>}
    {hasSubmenu && <ChevronRight size={12} className="opacity-50" />}
  </button>
);
